import { Component, Input } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EasyDgdService } from '@hazmatsuite-next/easydgd-lib';
import { LanguageService } from '@hazmatsuite-next/ui';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'easydgd-footer-navigation-buttons',
  templateUrl: './footer-navigation-buttons.component.html',
  styleUrls: ['./footer-navigation-buttons.component.scss'],
})
export class FooterNavigationButtonsComponent {
  @Input() hideNext = false;

  public commonResource$: Observable<{ [key: string]: string; }> = this.languageService.translations$.pipe(
    map(translations => translations['EasyDgdCommonResource']));

  constructor(private languageService: LanguageService,
    private easyDgdService: EasyDgdService,
    private activatedRoute: ActivatedRoute,
    public controlContainer: ControlContainer) { }

  public previous(): void {
    // this.easyDgdService.activatePreviousStep(this.activatedRoute);
  }

  public next(): void {
    if (!this.controlContainer.control || this.controlContainer.control.valid) {
      // this.easyDgdService.activateNextStep(this.activatedRoute);
    } else {
      this.controlContainer.control.markAllAsTouched();
    }
  }
}
